import React from "react";
import { render } from 'storyblok-rich-text-react-renderer';

const RichTextField = ({ data }) => {
    return <div>{render(data)}</div>;
};

export default RichTextField;
